export default "__VITE_ASSET__BjpZgAWq__"